import Request from 'core/api/Request';

import urlResolver from 'admin/utils/URLResolver';

export function uniqueId(prefix = '', entropy = 8) {
  let text = '';
  const possible =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  for (let i = 0; i < entropy; i += 1) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return `${prefix}${text}`;
}

export async function generateSignedForm(key, contentType) {
  const url = urlResolver.reverse('api:asset-upload-form');
  const response = await Request.post(url)
    .send({ key, content_type: contentType })
    .end();
  if (response.ok) {
    return response.body;
  }
  throw response;
}

export async function uploadAsset(file, prefix) {
  const knownFilename = file.name ? file.name : '';
  const key = `${prefix}${knownFilename}`;
  const signedForm = await generateSignedForm(key, file.type);
  const formData = new window.FormData();
  Object.keys(signedForm.fields).forEach((k) =>
    formData.append(k, signedForm.fields[k])
  );
  formData.append('file', file);

  // we're using fetch here in order to avoid setting up CORS policies on our S3 bucket
  // fetch allows a request that posts without accessing the request body so no CORS errors
  // are raised.
  await window.fetch(signedForm.url, {
    method: 'POST',
    body: formData,
    mode: 'no-cors',
  });

  return { url: `${signedForm.public_url}` };
}
